import { CookieService } from '@/app_lib/CookieService';

const redirectCookieOptions = {
  expires: 2,
  sameSite: 'Lax' as const,
  secure: true,
};

export function getRedirectDestination(cookieKey: string): string {
  return CookieService.get(cookieKey) ?? '/';
}

export function clearRedirectCookie(cookieKey: string): void {
  CookieService.remove(cookieKey);
}

export function setRedirectCookie(cookieKey: string, value: string): void {
  CookieService.set(cookieKey, value, redirectCookieOptions);
}

/**
 * Link to `/signin` that returns the user to the current page after login.
 * Bare `/` (no query) → `/signin` with no `signin_redirect`; otherwise adds `signin_redirect`.
 */
export const buildSignInRedirectUrl = (location: Location, format: 'absolute' | 'relative'): string => {
  const query = new URLSearchParams(location.search).toString();
  const pathAndQuery = `${location.pathname}${query ? `?${query}` : ''}`;

  const relativeHref =
    pathAndQuery === '/' ? '/signin' : `/signin?${new URLSearchParams([['signin_redirect', pathAndQuery]]).toString()}`;

  return format === 'absolute' ? `${location.origin}${relativeHref}` : relativeHref;
};
